module.exports = __webpack_public_path__ + "img/index_part2img4.1bd9f22b.jpg";